import { render, staticRenderFns } from "./right-menu.vue?vue&type=template&id=477d3f52&scoped=true&"
import script from "./right-menu.vue?vue&type=script&lang=js&"
export * from "./right-menu.vue?vue&type=script&lang=js&"
import style0 from "./right-menu.vue?vue&type=style&index=0&id=477d3f52&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477d3f52",
  null
  
)

export default component.exports